export const shadows = {
  sm: `0px 2px 6px #E5E5E5`,
  xs: `0px 1px 2px #E5E5E5`,
};
